<template>
  <div class="lecion-null-bg" @click.stop>
    <img class="close-icon" src="~/assets/imgs/detail_close.png" @click="close" />
    <div class="title">
      <img src="~/assets/imgs/fail.png" @click="close" />
    </div>
    <div class="content">积分不足，无法兑换</div>
    <div class="count">我的积分：{{ props.detail.balance }}</div>
    <div class="footer">
      <div class="confirm" @click="close">确定</div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { defineEmits, defineProps } from "vue";

const emit = defineEmits(["close"]);
const props = defineProps<{
  detail: {};
}>();
/**
 * @description 关闭弹窗
 * @return {void}
 */
const close = () => {
  emit("close");
};
</script>
<style scoped lang="scss">
.lecion-null-bg {
  width: 13.25rem;
  background: #fff;
  position: relative;
  border-radius: 0.5rem;

  .close-icon {
    width: 0.9rem;
    height: 0.9rem;
    position: absolute;
    top: 0.6rem;
    right: 0.6rem;
  }

  .title {
    margin: 1rem 0 1rem 50%;
    transform: translateX(-50%);
    text-align: center;
    width: 1.5rem;
    height: 1.5rem;
  }

  .content {
    color: #000;
    font-size: 0.685rem;
    font-weight: 600;
    text-align: center;
  }

  .count {
    color: #999;
    font-size: 0.515rem;
    text-align: center;
    margin-top: 0.4rem;
  }

  .footer {
    font-size: 0.7rem;
    display: flex;
    justify-content: center;

    .confirm {
      height: 1.68rem;
      line-height: 1.68rem;
      width: 50%;
      background: #ff7210;
      color: #fff;
      text-align: center;
      border-radius: 1rem;
      margin: 1.3rem 0 0.88rem 0;
    }
  }
}
</style>
